// @core/api/endpoints/calendar/list_my_events.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListEventsResponse,
} from '../../../types/calendar';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/calendar';

/**
 * List my events
 * Returns events across all calendars accessible to the current user within the specified date range. Useful for daily/weekly agenda views.
 */
export async function ListMyEvents(
  params?: PaginatedRequest & {
    time_max?: string | number | boolean;
    time_min?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListEventsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/events/my`;
  const requestOptions = options;
  return client.get<ListEventsResponse>(requestPath, { ...requestOptions, params });
}
